import styled from 'styled-components';

export const PageContainer = styled.div`
  height: 100%;
  padding: 20px;
  overflow-y: auto;
`;

export const StepContainer = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
`;

export const TableContainer = styled.div`
  margin-top: 16px;
  border-radius: 12px;
  ${(props) => props.theme.boxShadows.shadowLarge}
  min-width: 980px;
  position: relative;
`;

export const FileUploadContainer = styled.div`
  margin: 16px 0 16px 0;
  padding: 16px;
  border-radius: 12px;
  ${(props) => props.theme.boxShadows.shadowMedium};
  overflow: scroll;
`;
